/**
 * Centralized Dayjs Configuration
 *
 * This module configures dayjs with all required plugins in one place.
 * Import dayjs from this module instead of directly from 'dayjs' to ensure
 * all plugins are properly initialized.
 *
 * Plugins included:
 * - utc: UTC timezone support
 * - timezone: Timezone conversion support
 * - isoWeek: ISO week support
 */

import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

// Extend dayjs with all required plugins
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isoWeek)

// Export the configured dayjs instance
export default dayjs
